<div class="tc-icon-wrap {{ iconClass }}"></div>
